import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)
if (navigator.userAgent == "Comfamiliar-Gimnasios-Desktop-App") {
    // Vue.http.options.root = 'https://staging.fusepong.com/api/';
    Vue.http.options.root = 'https://solutions.fusepong.com/api/';

} else {
    Vue.http.options.root = 'https://solutions.fusepong.com/api/';
    // Vue.http.options.root = 'https://newsolutions.fusepong.com/api/';
    // Vue.http.options.root = 'http://localhost:4000/api/';
    // Vue.http.options.root = 'https://staging.fusepong.com/api/';
    // Vue.http.options.root = 'https://prod-migration.fusepong.com/api/';
}
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*'
Vue.http.headers.common['Accept-Language'] = 'es'
Vue.http.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, Authentication, Accept-Language'
Vue.http.headers['Access-Control-Max-Age'] = '1728000'



// WEBPACK FOOTER //
// ./src/vue/resource/index.js